import { Dispatch, FC, SetStateAction, useState } from "react";
import PopupModal from "../../../UI/Popup";
import CustomButton from "../../../UI/Buttons/CustomButton";
import { useAppDispatch as useDispatch, useAppSelector as useSelector } from "../../../../store";
import { blockUnblockCandidateThunk } from "../../../../store/centers/thunks";
import { isFulfilled } from "@reduxjs/toolkit";
import { showNotificationAction } from "../../../../store/application/slice";
import { TBlockUnBlockCandidatePayload } from "../../../../models/vacancy";
import TextArea from "../../../UI/Inputs/TextArea";
import Warning from "../../../UI/Icons/Warning";

interface BlockCandidateProps {
  showBlockModal: boolean;
  onClickClose: () => void;
  blockCandidateId: number;
  blockCandidateName: string | null;
  setShowBlockModal: Dispatch<SetStateAction<boolean>>
}

const BlockCandidate: FC<BlockCandidateProps> = ({
  showBlockModal,
  onClickClose,
  blockCandidateId,
  blockCandidateName,
  setShowBlockModal
}) => {
  const dispatch = useDispatch();

  const inProgress = useSelector((state) => state.Centres.inProgress);

  const [blockReason, setBlockReason] = useState<string | null>(null);

  const handleBlockCandidate = async() => {
    const payload: TBlockUnBlockCandidatePayload = {
      action: "block",
      user_id: blockCandidateId,
      reason: blockReason
    }
    const res = await dispatch(blockUnblockCandidateThunk(payload))
    if(isFulfilled(res)){
      setShowBlockModal(false)
      dispatch(showNotificationAction('Completed'))
    }
  }

  return (
    <>
      <PopupModal
        visible={showBlockModal}
        showCloseBtn={true}
        onClickClose={onClickClose}
        customWidth={650}
      >
        <div className="d-flex flex-column gap-20">
          <div className="d-flex flex-column gap-15">
            <div className="fs-22 fw-400 text-black">
              Block {blockCandidateName}
            </div>
            <div className="d-flex flex-column gap-8">
              <div className="fs-13 fw-400 text-black">
                You are about to block {blockCandidateName}. Blocking them will
                mean your centres will not be visible to them and they may not
                apply or accept your vacancies.
              </div>
              <div className="fs-13 fw-400 text-black">
                Candidates will not be notified when they are blocked.
              </div>
              <div className="fs-13 fw-400 text-black">
                Please include a reason as reference for other Centre Admin and Centre Users in your team.
              </div>
            </div>
            <div className="d-flex flex-column gap-8">
              <TextArea
                field={"comment"}
                placeholder={"Enter a Reason"}
                onChange={(e) => setBlockReason(e.target.value)}
              />
            </div>
            <div className="bg-teal-light px-15px py-10px radius-8px d-flex gap-6">
              <Warning />
              <div className="fs-13 fw-400 text-black lh-sm">
                The Centre Admin in your team are also managing the following centres you are not assigned 
                to: Bravo Centre, Charlie Centre, Delta Centre. Blocking this candidate will block them from 
                these centres and your assigned centres.
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-end">
            <CustomButton
              variant={"primary"}
              type="button"
              disabled={!blockReason}
              className="btn-theme bg-alert text-white fw-700"
              onClick={handleBlockCandidate}
              isLoading={inProgress}
              contentClass="d-flex"
            >
              Confirm and Block
            </CustomButton>
          </div>
        </div>
      </PopupModal>
    </>
  );
};

export default BlockCandidate;